module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n    Reschedule appointments in this series\n  ")]), _vm._v(" "), (!_vm.success) ? _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "type": "number",
      "label": "days"
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "type": "number",
      "label": "hours",
      "min": -24,
      "max": 24
    },
    model: {
      value: (_vm.hours),
      callback: function($$v) {
        _vm.hours = $$v
      },
      expression: "hours"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mx-3",
    attrs: {
      "type": "number",
      "label": "minutes",
      "min": -60,
      "max": 60
    },
    model: {
      value: (_vm.minutes),
      callback: function($$v) {
        _vm.minutes = $$v
      },
      expression: "minutes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-switch', {
    attrs: {
      "persistent-hint": "",
      "label": "Only apply rescheduling to this appointment and appointments that start after it",
      "hint": _vm.rescheduleHintText
    },
    model: {
      value: (_vm.futureOnly),
      callback: function($$v) {
        _vm.futureOnly = $$v
      },
      expression: "futureOnly"
    }
  })], 1)], 1) : _c('v-card-text', [_c('blockquote', {
    staticClass: "blockquote"
  }, [_vm._v("\n      Appointments successfully rescheduled\n      "), _c('v-btn', {
    attrs: {
      "to": "/calendar",
      "outlined": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n        Return to calendar\n      ")])], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.success,
      "loading": _vm.loading,
      "color": "error"
    },
    on: {
      "click": _vm.performReschedule
    }
  }, [_vm._v("\n      Reschedule appointments\n    ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ccf2ef","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/RescheduleRecurringAppointmentForm.vue
// module id = 1364
// module chunks = 9